/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassStaggerRef,
  UnifiedClassStaggerRefOptional,
  UnifiedClassStaggerRefMetaI,
  UnifiedClassStaggerRefTrackedI,
} from "./unified-class-stagger-ref";
import {
  UnifiedClassStaggerRefTracked,
  UnifiedClassStaggerRefMeta,
} from "./unified-class-stagger-ref";

/**
 *
 * @export
 * @interface WithStaggerRef
 */
export interface WithStaggerRefOptional {
  /**
   *
   * @type {UnifiedClassStaggerRef}
   * @memberof WithStaggerRef
   */
  staggerId?: UnifiedClassStaggerRefOptional;
}

export interface WithStaggerRef extends WithStaggerRefOptional {
  /**
   *
   * @type {UnifiedClassStaggerRef}
   * @memberof WithStaggerRef
   */
  staggerId?: UnifiedClassStaggerRef;
}

export interface WithStaggerRefTrackedI {
  /**
   *
   * @type {UnifiedClassStaggerRef}
   * @memberof WithStaggerRef
   */
  staggerId?: UnifiedClassStaggerRefTrackedI;
  staggerIdIsSet: boolean;
}

transformDatesMap.set("WithStaggerRef", function (model: WithStaggerRef) {
  const transformDatesstaggerId = transformDatesMap.get(
    "UnifiedClassStaggerRef",
  );
  if (transformDatesstaggerId && model.staggerId) {
    transformDatesstaggerId(model.staggerId);
  }
});

export type WithStaggerRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  staggerId: PropertyMeta<UnifiedClassStaggerRefMetaI>;
}>;

export var WithStaggerRefMeta: WithStaggerRefMetaI = {} as WithStaggerRefMetaI;
WithStaggerRefMeta = typeMeta("WithStaggerRef", {
  staggerId: propertyMeta(
    "staggerId",
    false,
    false,
    false,
    UnifiedClassStaggerRefMeta,
  ),
});

const metaI = WithStaggerRefMeta;

registerMeta(() => {});

export class WithStaggerRefTracked implements WithStaggerRefTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  staggerId__I?: UnifiedClassStaggerRefTracked = undefined;
  staggerIdIsSet: boolean = false;
  set staggerId(v: undefined | UnifiedClassStaggerRefTracked) {
    if (v !== undefined) {
      this.staggerId__I = v;
      this.staggerIdIsSet = true;
    } else {
      this.staggerId__I = v || undefined;
      this.staggerIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get staggerId() {
    return this.staggerId__I;
  }
  constructor(config?: WithStaggerRefOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.staggerId?.setIds();
  }
  assignFrom(
    config: WithStaggerRefOptional,
    options?: AssignOptions,
  ): WithStaggerRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.staggerId && this.staggerIdApplyFilter(optionsRequired.filter)) {
      this.staggerId = new UnifiedClassStaggerRefTracked(
        config.staggerId,
        options,
      );
      if (optionsRequired.unassign) this.staggerIdIsSet = false;
      else this.staggerIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithStaggerRefTrackedI {
    const cloned = {} as WithStaggerRefTrackedI;
    if (
      this.staggerIdIsSetDeep() &&
      this.staggerIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.staggerIdIsSet = true;
      cloned.staggerId = this.staggerId?.removeUnset(filter);
    } else {
      //cloned.staggerIdIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithStaggerRefTrackedI {
    if (!this.staggerIdApplyFilter(filter)) this.staggerIdIsSet = false;
    this.staggerId?.unassignAll(filter);

    return this;
  }
  staggerIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WithStaggerRefMeta.staggerId,
      WithStaggerRefMeta,
      this.staggerId,
      this,
    );
  }
  staggerIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.staggerIdIsSet && this.staggerIdApplyFilter(filter)) return true;
    return this.staggerId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.staggerIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
